import Vue from 'vue';
import App from './App.vue';
import router from './router';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueClipboard from 'vue-clipboard2';

window.moment = require('moment');

Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.config.productionTip = false;

import {api} from './mixins/api.js';
Vue.mixin(api);

import {alerts} from '@/mixins/alerts.js';
import {utils} from '@/mixins/utils.js';


new Vue({
    router,
    render : h => h(App),
    mounted : function () {
        let self = this;

    },
    beforeMount () {
        this.getQueryParams();
    },
    data : function () {

        let env = 'prod',
            env_url = 'https://form-backend.mobilerocket.co.uk';
        if (window.location.protocol === 'http:') {
            env = 'dev';    // dev doesn't run over https
            env_url = 'https://forms.test';
        }

        return {
            loading     : true,
            profile     : {},
            user_id     : 0,
            user_type   : 'none',
            credit      : 0,
            env         : env,
            env_url     : env_url
        };
    },
    watch : {

    },
    mixins : [alerts],
    methods : {
        getQueryParams () {
            let qstring = location.search;
            console.log('check query string', qstring);
            if (qstring.length > 1) {
                // check for the user id and token in the query string.
                let search = qstring.substring(1);
                let sp = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) {
                    return key==="" ? value : decodeURIComponent(value);
                });
                // if it finds both, we do the sso login
                if (sp.i && sp.t) {
                    let params = {
                        id : sp.i,
                        token : sp.t
                    };
                    if (sp.a) {
                        params.app_id = sp.a;
                    }
                    this.ssoLogin(params);
                } else {
                    this.checkLogin();
                }
            } else {
                this.checkLogin();
            }
        },
        ssoLogin (params) {
            this.loading = true;
            console.log('sso login', params);
            window.history.replaceState({}, document.title, "/");
            this.axios.post(this.env_url + '/api/auth/sso', params)
                .then(response => {
                    console.log('logged in', response.data);
                    this.login(response.data.access_token);
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not log you in.');
                    this.loading = false;
                    this.error = true;
                    console.error('error authenticating', error);
                });
        },
        clearUserId () {
            this.user_id = 0;
        },
        checkLogin () {
            console.log('checking login');
            if (localStorage.getItem('builder.token')) {
                let token = localStorage.getItem('builder.token');
                this.login(token, true);
            } else {
                this.clearToken();
                this.clearProfile();
                this.loading = false;
            }
        },
        clearProfile () {
            this.profile = {};
            this.user_id = 0;
            this.user_type = 'none';
        },
        setUserId(id) {
            if (this.user_type !== 'rocket') {
                return;
            }
            this.user_id = id;
            localStorage.setItem('builder.user_id', id);
        },
        getUserId() {
            if (localStorage.getItem('builder.user_id')) {
                this.user_id = localStorage.getItem('builder.user_id');
                return this.user_id;
            } else {
                this.user_id = 0;
            }
            return 0;
        },
        setProfile (data) {
            this.profile = data;
            
            if (data.is_admin) {
                this.user_type = 'rocket';
                this.getUserId();
            } else {
                this.user_id = data.business_id;
                if (data.readonly) {
                    this.user_type = 'readonly';
                } else {
                    this.user_type = 'write';
                }
            }
        },
        setToken (token) {
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            localStorage.setItem('builder.token', token);
        },
        clearToken () {
            this.axios.defaults.headers.common['Authorization'] = null;
            localStorage.removeItem('builder.token');
        },
        login (token, noRedirect) {
            this.loading = true;
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            this.axios.post(this.env_url + '/api/auth/me')
                .then(response => {
                    this.setProfile(response.data);
                    this.setToken(token);
                    // by default we redirect back to home.
                    if (!noRedirect) {
                        this.$router.replace({ name : 'index' });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.logout();
                });
        },
        logUserIn:function(id)
        {
            if (this.user_type === 'rocket') {
                this.user_id = id;
                this.$router.push({ name : 'index' });
            } else {
                this.$router.replace({ name : 'index' });
            }
        },
        logout () {
            this.clearToken();
            this.clearProfile();
            this.loading = false;
            this.$router.replace({ name : 'index' });
        }
    }
}).$mount('#app');
